import React, { PropTypes } from 'react'
import { connect } from 'react-redux'

const CustomErrors = ({ __errors, __submitted }) => {
  if (!__submitted) {
    return null
  }

  if (!__errors.length) {
    return null
  }

  return (
    <div className="alert alert-danger">
      <h5>Some fields in the form are invalid.</h5>
      <ul>
        { __errors && __errors.map((err, k) => (
          <li key={k}>{err}</li>
        )) }
      </ul>
    </div>
  )
}

CustomErrors.propTypes = {
  __errors: PropTypes.array,
  __submitted: PropTypes.bool,
}

function mapStateToProps(state) {
  const _form = state.forms.admissionState
  const __errors = []
  Object.entries(_form).map((v) => {
    if (v[0] !== '$form' && v[0] !== 'meta' && !v[1].valid) {
      __errors.push(v[0])
    }
    return false
  })
  return {
    __errors,
    __submitted: state.forms.admissionState.$form.submitFailed,
  }
}

export default connect(mapStateToProps)(CustomErrors)



// WEBPACK FOOTER //
// ./src/containers/Admission/custom-errors.js